export default __webpack_public_path__ + "static/media/down.8c82611a.svg";